<template>
    <app-basket @addToBasket="addHandler">

        <template #default>
            <div class="basket-notifications-handler">
                <transition name="basket-notification">
                    <div class="basket-notifications-handler__wrapper" v-if="product">

                        <div class="basket-notifications-handler__header">
                            <h3 class="basket-notifications-handler__title glitch-text glitch-text--basket-popup">Товар добавлен в корзину</h3>

                            <button type="button" @click.prevent="closeNotification" class="basket-notifications-handler__close">
                                <svg width="24" height="24">
                                    <use xlink:href="/sprite.svg#icon-close"></use>
                                </svg>
                            </button>
                        </div>
                        <div class="basket-notifications-handler__notification">
                            <basket-notification :product="product" />
                        </div>
                        <div class="basket-notifications-handler__footer">
                            <a href="/personal/order/make/" class="btn btn-block btn-main">Перейти в корзину</a>
                        </div>

                        <div class="basket-notifications-handler__delivery" v-if="product.deliveryPeriods">
                            <div class="basket-notifications-handler__delivery-title">Сроки доставки заказа:</div>
                            <ul class="basket-notifications-handler__delivery-list">
                                <li class="basket-notifications-handler__delivery-item">
                                    <svg width="20" height="20">
                                        <use xlink:href="/sprite.svg#icon-delivery"></use>
                                    </svg>
                                    <div>
                                        <span v-if="product.deliveryPeriods.DAYS_STRING != 'часа'">
                                            В пункт выдачи <b>Boxberry</b> в <a class="basket-notifications-handler__city-link" data-toggle="modal" data-target="#regionModal" href="#">{{cityNameHandled}}</a>:
                                        </span>
                                        <span v-if="product.deliveryPeriods.DAYS_STRING == 'часа'">Доставка: </span>
                                        <span class="basket-notifications-handler__delivery-item--info">{{ product.deliveryPeriods.DAYS }} {{ product.deliveryPeriods.DAYS_STRING }}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </transition>
            </div>
        </template>

    </app-basket>
</template>

<script>
import AppBasket from './app-basket';
import BasketNotification from './basket-notification';

export default {
    name: 'basket-notifications-handler',
    inject: ['$userGeoService'],
    components: { BasketNotification, AppBasket },

    data() {
        return {
            product: null,
            cityName: '',
        };
    },

    methods: {
        addHandler(product) {
            this.product = {
                ...product,
            };
        },

        closeNotification() {
            this.product = null;
        },

    },

    computed: {
        cityNameHandled() {
            let name = this.$userGeoService.getSettledRegion();
            const lastLetter = name.slice(-1);
            if (lastLetter.toLowerCase() === 'а') {
                name = `${name.substr(0, name.length - 1)}у`;
            }
            return name;
        },
        notificationClassNames() {
            return {
                'basket-notifications-handler__notification': true,
                'basket-notifications-handler__notification--show': Boolean(this.product),
            };
        },
    },
};
</script>
